module.exports = __webpack_public_path__ + "img/joe.8654d5bb.webp";